import availableStates from '@/util/availableStates'
import { format } from 'date-fns'
import { formatAmount } from '@/util/helpers'
import subscriptionStatuses from '@/util/subscriptionStatuses'

export default function () {
  return {
    availableStates,
    subscriptionStatuses,
    format,
    formatAmount,
    showCalendar: false,
    calendarFocus: '',
    errors: {},
    user: {
      id: null,
      name: '',
      biography: '',
      cpf: '',
      birthDate: '',
      classValue: null,
      email: '',
      orders: [],
      vouchers: [],
      specializations: [],
      teachingModalities: [],
      schedules: [],
      nativeSpeaker: null,
      resident: null,
      roles: [],
      address: {
        street: '',
        number: null,
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
      },
    },
  }
}
